import { gql } from "@apollo/client"

export const GET_NOTIFICATION_LIST_QUERY = gql`
    query notificationsList(
        $filter: FilterFindManyNotificationInput
        $nextToken: ID
        $sort: SortFindManyNotificationInput
    ) {
        notificationsList(filter: $filter, nextToken: $nextToken, sort: $sort) {
            records {
                message
                _id
                readAt
                severity
                userId
                _metadata {
                    createdAt
                }
                notificationTopic {
                    name
                }
            }
            nextToken
        }
    }
`
